import { AbstractControl, FormControl, ValidationErrors, Validators } from '@angular/forms';
import isEmail from 'validator/lib/isEmail';

export const PASSWORD_SPECIAL_CHARACTERS = [
  '!',
  '@',
  '#',
  '$',
  '%',
  '^',
  '&',
  '*',
  '+',
  '-',
  '?',
  '~',
  '(',
  ')',
  '.',
  '/',
  ':',
  '<',
  '=',
  '>',
];
export const PASSWORD_SPECIAL_CHARACTERS_ERROR_MESSAGE = `Must include 1 special character.`;
const REGEX_SPECIAL_CHARACTERS = ['[', ']', '\\', '^', '$', '.', '|', '?', '*', '+', '-', '(', ')', '{', '}'];
const PASSWORD_SPECIAL_CHARS_ESCAPED = PASSWORD_SPECIAL_CHARACTERS.map((char) =>
  REGEX_SPECIAL_CHARACTERS.some((specialChar) => specialChar === char) ? '\\' + char : char,
);

export class CustomValidators {
  // - is a special character in regex and must be escaped. With a slash.  Double slash is needed to insert a literal \
  // character rather than a string escape sequence.
  private static readonly _SPECIAL_CHARS_REGEX: RegExp = new RegExp(`[${PASSWORD_SPECIAL_CHARS_ESCAPED.join('')}]`);
  private static readonly _UPPERCASE_REGEX: RegExp = /[A-Z]/;
  private static readonly _DIGIT_REGEX: RegExp = /\d/;

  static oneDigit(control: FormControl<string | null>): ValidationErrors | null {
    if (!!control.value) {
      const isValid = CustomValidators._DIGIT_REGEX.test(control.value);
      return isValid ? null : { oneDigit: true };
    }

    return null;
  }

  static oneUppercase(control: FormControl<string | null>): ValidationErrors | null {
    if (!!control.value) {
      const isValid = CustomValidators._UPPERCASE_REGEX.test(control.value);
      return isValid ? null : { oneUppercase: true };
    }

    return null;
  }

  static oneSpecialChar(control: FormControl<string | null>): ValidationErrors | null {
    if (!!control.value) {
      const isValid = CustomValidators._SPECIAL_CHARS_REGEX.test(control.value);
      return isValid ? null : { oneSpecialChar: true };
    }

    return null;
  }

  static passwordMatch(form: AbstractControl): ValidationErrors | null {
    const pw1 = form.get('password');
    const pw2 = form.get('password2');
    if (!!pw1 && !!pw2) {
      if (pw1.value !== pw2.value) {
        return { passwordMatch: true };
      }
    }

    return null;
  }

  /**
   * Validates an input as having an RFC822 email, without a display name or comments and having a top level domain (TLD).
   */
  static emailAddressPartOnly(control: AbstractControl): ValidationErrors | null {
    if (!!control.value) {
      // By default, isEmail does not allow display name.
      if (!isEmail(control.value)) {
        return { emailAddressPartOnly: true };
      }
    }
    return null;
  }
}

export const PASSWORD_INPUT_VALIDATORS = [
  Validators.required,
  Validators.minLength(8),
  Validators.maxLength(20),
  CustomValidators.oneDigit,
  CustomValidators.oneUppercase,
  CustomValidators.oneSpecialChar,
];
